import Swal from "sweetalert2";
import { useAbm } from "../../../../services/abm";
import { useAbmContext } from "../../../../views/abm/useAbmComponent";
import { ActionButton } from "../../../helpers";
import { DeleteIcon } from "../../../icons";

export const EliminarConteoPublico = ({params}) => {
  const actividades = useAbm({entity: "actividades"});
  const { loadDetails } = useAbmContext();

  const handleClick = () => {
    Swal.fire({
      icon: "question",
      title: "Eliminar conteo de público",
      html: "¿Desea eliminar el conteo de público de la actividad?",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Sí, eliminar",
      denyButtonText: "Cancelar",
    }).then((result) => {
      if(!result.isConfirmed) return;

      actividades
        .remove("conteo-publico", `actividades/${params.id}`)
        .then(() => loadDetails(params.id));
    });
  };

  return (
    <ActionButton
      iconButton
      enabled={true}
      Icon={DeleteIcon}
      htmlColor="var(--bs-danger)"
      onClick={handleClick}
    />
  );
};
